import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ThirdParty } from 'src/app/core/interfaces/thirdParty';
import { ThirdPartyDetailComponent } from '../third-party-detail/third-party-detail.component';
import { Global } from 'src/app/core/resources/global';

@Component({
  selector: 'app-third-party-item',
  templateUrl: './third-party-item.component.html',
  styleUrls: ['./third-party-item.component.scss']
})
export class ThirdPartyItemComponent {

  @Input() thirdParty: ThirdParty;
  constructor(
    public dialog: MatDialog,
    private global: Global
  ) { }

  getDocumentType(): string {
    if (!this.thirdParty || !this.thirdParty.documentType) return '-';
    const documentType = this.global.documenTypes.find(type => type.id === this.thirdParty.documentType);
    return documentType ? documentType.name : '-';
  }

  goToDetail() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      thirdParty: this.thirdParty,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(ThirdPartyDetailComponent, dialogConfig);
  }

}
